

import GoogleMapReact from 'google-map-react'


const GoogleMapComponent = () => {

    const defaultProps = {
        center: {
            lat: 18.516691130307642,
            lng: -72.28390412443903
        },
        zoom: 11
    };

    return (
        <>

            <div className='h-[65vh]  lg:w-[60%] md:w-[80%] sm:w-[100%] m-auto '>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: "" }}
                    defaultCenter={defaultProps.center}
                    defaultZoom={defaultProps.zoom}
                >
                </GoogleMapReact>
            </div>
        </>
    )
}

export default GoogleMapComponent